/**
 * 期间筛选
 */
export default {
    label: "期间",
    init(filter) {
        var date = new Date(),
            month = date.getFullYear() * 100 + date.getMonth() + 1;
        filter.value = [month, month];
        filter.begin = month;
        filter.end = month;
    },
    handler(filter, vm) {
        vm.$weui.monthPicker(function (begin, end) {
            filter.value = [begin, end];
            filter.begin = begin;
            filter.end = end;
            vm.onChange(filter);
        });
    },
    renderer(filter) {
        var b = filter.begin,
            e = filter.end;
        if (b) {
            if (b == e) {
                return b;
            }
            return b + " 至 " + e;
        }
        return filter.label;
    },
    /**
     * 返回期间条件
     * @param {*} value 
     * @param {*} filter 
     */
    fn(value, filter) {
        if (filter.begin) {
            return {
                type: "date",
                field: filter.name,
                operation: "between",
                value: filter.begin + "," + filter.end
            };
        }
    }
};